export const contentTableConfig = {
  title: '客户列表',
  propList: [
    { prop: 'nickName', label: '昵称', minWidth: '80', slotName: 'consumer', align: 'left'},
    { prop: 'unionId', label: 'unionId', minWidth: '100' },
    { prop: 'wxAccount', label: '工作微信账号', minWidth: '80' },
    { prop: 'empName', label: '所属业务员', minWidth: '60' },
    { prop: 'groupName', label: '所属组别', minWidth: '60' },
    { prop: 'corpName', label: '主体名称', minWidth: '80' },
    { prop: 'createdAt', label: '加入时间', minWidth: '80', sortable: true },
    { prop: 'succTime', label: '成交时间', minWidth: '80', sortable: true },
    { prop: 'succAmount', label: '成交金额', minWidth: '70', sortable: true }
  ],
  showSelectColumn: false
}
